export const PROTOCOL_VERSION = 1;

export const MAX_TEXT_CHARS = 50_000;
export const MAX_FILES_PER_MESSAGE = 5;
export const MAX_FILE_BYTES = 20 * 1024 * 1024;
export const MAX_MESSAGE_FILES_BYTES = 40 * 1024 * 1024;

export const MAX_HISTORY_MESSAGES = 200;
export const HISTORY_PAGE_SIZE = 100;
export const MAX_QUEUE_MESSAGES = 20;

export const SESSION_COOKIE = "relay_session";
export const SESSION_TTL_SECONDS = 7 * 24 * 60 * 60;

export const LOGIN_MAX_ATTEMPTS = 5;
export const LOGIN_WINDOW_MS = 15 * 60 * 1000;
export const GLOBAL_LOGIN_MAX_ATTEMPTS = 30;
export const GLOBAL_LOGIN_WINDOW_MS = 60 * 60 * 1000;

export const R2_PREFIX = "uploads/";
export const FILE_TTL_MS = 7 * 24 * 60 * 60 * 1000;
export const R2_CLEANUP_LIMIT = 1000;

export const AUTH_DEFAULT_ITERATIONS = 600_000;
export const AUTH_VERIFIER_BYTES = 32;
export const AUTH_SALT_BYTES = 16;

export const ALLOWED_EXTENSIONS = [
  "pdf",
  "txt",
  "md",
  "markdown",
  "csv",
  "json",
  "html",
  "htm",
  "xml",
  "yaml",
  "yml",
  "log",
  "docx",
  "xlsx",
  "pptx",
] as const;

export type AllowedExtension = (typeof ALLOWED_EXTENSIONS)[number];

export const EXTENSION_MIME: Record<AllowedExtension, string> = {
  pdf: "application/pdf",
  txt: "text/plain",
  md: "text/markdown",
  markdown: "text/markdown",
  csv: "text/csv",
  json: "application/json",
  html: "text/html",
  htm: "text/html",
  xml: "application/xml",
  yaml: "application/yaml",
  yml: "application/yaml",
  log: "text/plain",
  docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  pptx: "application/vnd.openxmlformats-officedocument.presentationml.presentation",
};

export const TEXT_EXTENSIONS: ReadonlySet<string> = new Set([
  "txt",
  "md",
  "markdown",
  "csv",
  "json",
  "html",
  "htm",
  "xml",
  "yaml",
  "yml",
  "log",
]);

export const ZIP_EXTENSIONS: ReadonlySet<string> = new Set(["docx", "xlsx", "pptx"]);
